export enum BusinessFileClassificationsEnum {
  Unknown = 0,
  BusinessFile = 1,
  Flyer = 2
}
